import { jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Dropdown, Flex, theme } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { ReactComponent as BurgerMenuIcon } from "./../../../assets/icons/burger-menu.svg";
import useBurgerMenu from "./../../../hook/useBurgerMenu.js";
import "./burgerMenu.css";
const BurgerMenu = ({ menuItems, showSelectLanguage }) => {
  const [open, setOpen] = useState(false);
  const { token } = theme.useToken();
  const { items } = useBurgerMenu({
    callback: setOpen,
    menuItems,
    showSelectLanguage
  });
  const onOpenChange = (flag, { source }) => source !== "menu" && setOpen(flag);
  return /* @__PURE__ */ jsx(
    Dropdown,
    {
      menu: { items },
      trigger: ["click"],
      overlayClassName: "burger-menu-dropdown",
      open,
      onOpenChange,
      children: /* @__PURE__ */ jsx(
        Flex,
        {
          align: "center",
          justify: "center",
          style: { cursor: "pointer", padding: "12px 0" },
          children: open ? /* @__PURE__ */ jsx(
            CloseOutlined,
            {
              style: { fontSize: 24, color: token.colorTextBase }
            }
          ) : /* @__PURE__ */ jsx(
            BurgerMenuIcon,
            {
              style: { width: 24, height: 24 },
              className: "stroke-base"
            }
          )
        }
      )
    }
  );
};
var stdin_default = BurgerMenu;
export {
  stdin_default as default
};
